import { ApiResponse } from "../../shared/types";
/**
 * @file api-client.ts
 * @description Helper giao tiếp API, hỗ trợ JWT từ Zustand persistence.
 */
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const storageStr = localStorage.getItem('auth-storage');
  let token: string | null = null;
  if (storageStr) {
    try {
      const parsed = JSON.parse(storageStr);
      token = parsed.state?.token || null;
    } catch (e) {
      console.warn('[API Client] Malformed auth-storage detected:', e);
    }
  }
  const headers = new Headers(init?.headers);
  headers.set('Content-Type', 'application/json');
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  try {
    const res = await fetch(path, { ...init, headers });
    if (res.status === 401) {
      console.warn('[API Client] Unauthorized access. Clearing session.');
      localStorage.removeItem('auth-storage');
      localStorage.removeItem('auth-token');
      window.location.href = '/';
      throw new Error('Phiên đăng nhập hết hạn');
    }
    const json = (await res.json()) as ApiResponse<T>;
    if (!res.ok || !json.success || json.data === undefined) {
      const errorMsg = json.error || `Request failed with status ${res.status}`;
      console.error('[API Client] API Error:', errorMsg);
      throw new Error(errorMsg);
    }
    return json.data;
  } catch (error) {
    console.error('[API Client] Fetch Exception:', error);
    throw error;
  }
}